/**
 * The homepage headline, "The Free Research Hub for [Biohackers]", in direction B's style: Inter Black (.home-title in
 * index.css) with the last words in the brand colour over a violet swoosh. The last words rotate (RotatingWord.tsx,
 * the owner's call of 2026-10-24); the static shell and the first frame say "Biohackers".
 *
 * Lines: from 640px "The Free Research Hub for" and then the word on a line of its own; on a phone "The Free",
 * "Research Hub for", then the word, which keeps room for two lines there ("Performance Optimizers" wraps).
 *
 * Nothing here moves when Inter replaces the fallback font:
 *  - .home-title sizes the headline to the screen, so the same words share a line in either font.
 *  - Inter Black's space is 0.09em narrower than the fallback's, which would slide the next word along its line (by
 *    3.2px on "Research" at 54px, enough for Chrome to count a layout shift). So every word that follows another on a
 *    line starts at a fixed place: the words before it sit in boxes of their width in Inter Black at -0.025em
 *    ("The Free " 4.31em and "The Free Research Hub " 11.15em from 640px, "Research Hub " 6.84em on a phone), and the
 *    space ending each box is a non-breaking one, so it stays in the text. No whitespace may sit between the boxes.
 *    Change a word or the tracking and measure these widths again.
 *
 * The heading reads "The Free Research Hub for Biohackers" in the DOM, to crawlers and to screen readers.
 * index.html repeats this markup exactly inside its static shell; heroShell.test.tsx compares the two.
 */
import RotatingWord from "@/components/home/RotatingWord";

export default function HeroTitle() {
  return (
    <h1 className="home-title mt-6 text-foreground">
      <span className="whitespace-nowrap sm:inline-block sm:w-[11.15em]">
        <span className="sm:inline-block sm:w-[4.31em]">The Free&nbsp;</span>
        <br className="sm:hidden" />
        <span className="inline-block w-[6.84em] sm:inline sm:w-auto">Research Hub&nbsp;</span>
      </span>
      for <RotatingWord />
    </h1>
  );
}
